import React from 'react';

import type { FlagProps } from '../src/types';

const FlagJe = ({ className, testID }: FlagProps) => (
  <svg
    width={20}
    height={15}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    data-testid={testID}
    className={className}
    aria-hidden="true"
  >
    <mask
      id="prefix__a"
      maskUnits="userSpaceOnUse"
      x={0}
      y={0}
      width={20}
      height={15}
    >
      <path fill="#fff" d="M0 0h20v15H0z" />
    </mask>
    <g mask="url(#prefix__a)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0 0h20v15H0V0z"
        fill="#F7FCFF"
      />
      <path
        d="m-1.688.778-1.28-.774v15.492l1.28-.774 10.336-6.25 1.194-.722-1.194-.722L-1.688.778z"
        fill="#F7FCFF"
        stroke="#E31D1C"
        strokeWidth={1.688}
      />
      <path
        d="m21.826.77 1.267-.736v15.432l-1.267-.736-10.762-6.25-1.257-.73 1.257-.73L21.826.77z"
        fill="#F7FCFF"
        stroke="#E31D1C"
        strokeWidth={1.688}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.547 2.94S8.01 5.312 9.863 6.224c0 0 1.779-.97 1.38-3.286 0 0-.765-.255-1.372-.255-.608 0-1.324.255-1.324.255z"
        fill="#E31D1C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.739 3.437s.198-.088.296 0c.098.087.179-.008.179-.06 0-.054.156-.235.156-.088 0 .148-.049.23.088.23s.753-.203.901-.143c.148.06.261.046.224-.04-.038-.087-.135-.141-.32-.094-.187.047-.143.093-.303.093-.161 0-.34-.046-.34-.046s.05-.077.234-.022c.183.055.437-.068.505-.068.07 0 .259-.004.277.043.02.047.134.09.046.134-.087.044-.23.072-.132.128.1.056.327.046.338.104.01.059.119.146.075.146-.043 0-.121.083-.194.058-.073-.025-.082-.048-.012-.068.07-.02.07-.106.012-.106-.058 0-.03.03-.16 0-.132-.03-.305-.063-.295 0 .01.063.096.16-.062.174-.157.013-.231.065-.262.023-.03-.042-.14-.098-.054-.116.086-.018.169.061.2.048.03-.013.101-.02.042-.074-.059-.055-.156-.087-.066-.128.09-.04.02-.041-.152.043-.172.085-.267.156-.418.146-.15-.01-.207.004-.256-.01-.048-.014-.284.151-.352.11-.068-.042-.287-.058-.247-.11.039-.051.092-.078.151-.051.06.026.118.053.158.026.04-.026.154-.117.125-.135-.029-.019 0-.08-.164-.08s-.222.068-.26.025c-.04-.043.042-.092.042-.092zm.164.78s.174-.077.26 0c.086.077.157-.007.157-.053 0-.047.137-.207.137-.077s-.043.203.078.203c.12 0 .662-.18.792-.126.13.053.23.04.197-.036-.034-.076-.118-.124-.282-.082-.164.041-.125.082-.266.082-.142 0-.299-.04-.299-.04s.044-.069.206-.02c.161.048.384-.06.444-.06s.227-.004.244.038c.016.041.117.08.04.118-.077.038-.203.063-.116.112.087.05.287.04.297.092.01.051.104.128.066.128-.038 0-.107.072-.17.05-.065-.022-.072-.041-.011-.059.061-.018.06-.093.01-.093-.05 0-.026.026-.141 0-.115-.026-.268-.056-.259 0 .01.056.084.141-.054.152-.139.012-.203.057-.23.02-.027-.036-.124-.085-.048-.101s.148.054.176.042c.027-.011.089-.017.037-.065s-.137-.076-.058-.112c.08-.036.017-.037-.134.038-.151.074-.235.137-.368.128-.132-.009-.182.003-.224-.009-.043-.012-.25.133-.31.096-.06-.037-.252-.05-.218-.096.035-.045.082-.069.134-.045.052.023.103.046.138.023.035-.023.136-.103.11-.12-.025-.015 0-.069-.144-.069s-.195.06-.229.022.038-.081.038-.081zm.231.791s.132-.058.197 0c.066.059.12-.004.12-.04 0-.035.103-.156.103-.058s-.032.154.06.154c.09 0 .502-.136.6-.096.099.04.174.03.149-.027-.025-.058-.09-.094-.213-.062-.124.031-.095.062-.202.062-.107 0-.227-.03-.227-.03s.034-.052.156-.016c.122.037.291-.045.337-.045.046 0 .172-.003.185.029.012.031.089.06.03.09-.058.029-.154.047-.088.084.066.038.218.03.225.07.008.039.08.097.05.097-.028 0-.08.055-.129.038-.048-.016-.054-.031-.008-.045.047-.013.047-.07.008-.07-.038 0-.02.02-.107 0s-.203-.042-.196 0c.007.042.064.107-.041.115-.105.01-.154.044-.175.016-.02-.028-.093-.065-.036-.077.058-.012.112.04.133.032.02-.009.068-.014.028-.05-.039-.036-.104-.058-.044-.085.06-.027.013-.027-.101.029-.115.056-.178.104-.279.097-.1-.007-.138.003-.17-.007-.032-.009-.19.101-.235.073-.045-.028-.191-.038-.165-.073.026-.034.062-.052.1-.034.04.018.08.035.106.018.026-.018.103-.078.084-.09-.02-.013 0-.054-.11-.054s-.147.046-.173.017c-.026-.028.028-.062.028-.062z"
        fill="#FFD100"
      />
    </g>
  </svg>
);

export default FlagJe;
